import {
  Building2,
  Hotel,
  UtensilsCrossed,
  Coffee,
  Store,
  Building,
  Warehouse,
  GraduationCap,
  School,
  HeartPulse,
  Factory,
  Landmark,
} from "lucide-react";

/**
 * Data industri B2B SEJUKARA (structured content).
 */
export const industries = [
  { id: "perkantoran", icon: Building2, title: "Perkantoran", description: "Menjaga kenyamanan ruang kerja dan kestabilan operasional kantor." },
  { id: "hotel", icon: Hotel, title: "Hotel & Hospitality", description: "Perawatan sistem pendingin untuk kenyamanan tamu dan area publik." },
  { id: "restoran", icon: UtensilsCrossed, title: "Restoran", description: "Menjaga suhu ruang makan tetap nyaman untuk pengalaman pelanggan." },
  { id: "cafe", icon: Coffee, title: "Cafe", description: "Perawatan AC untuk kenyamanan area cafe dan pengunjung." },
  { id: "toko", icon: Store, title: "Toko & Retail", description: "Menjaga suhu ruang toko tetap nyaman bagi pelanggan dan staf." },
  { id: "property", icon: Building, title: "Property & Gedung", description: "Maintenance terencana untuk gedung dan fasilitas yang dikelola." },
  { id: "gedung-komersial", icon: Landmark, title: "Gedung Komersial", description: "Perawatan sistem AC & HVAC untuk gedung komersial." },
  { id: "gudang", icon: Warehouse, title: "Gudang & Fasilitas", description: "Dukungan perawatan pendingin untuk area operasional dan logistik." },
  { id: "sekolah", icon: School, title: "Sekolah", description: "Perawatan AC untuk ruang kelas dan fasilitas sekolah." },
  { id: "kampus", icon: GraduationCap, title: "Kampus & Universitas", description: "Perawatan AC untuk aula, ruang kuliah, dan fasilitas kampus." },
  { id: "healthcare", icon: HeartPulse, title: "Healthcare", description: "Perawatan sistem pendingin untuk fasilitas layanan kesehatan." },
  { id: "industri", icon: Factory, title: "Industri", description: "Maintenance AC & HVAC untuk kebutuhan fasilitas industri." },
];

export default industries;
